export default "__VITE_ASSET__HE8GKrO3__"